import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

import routerGuard from './guard'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/main/home'
  },
  {
    path: '/main',
    name: 'main',
    meta: {
      title: '主界面'
    },
    component: () => import('@/views/main/main.vue'),
    children: [
      {
        // 首页home
        path: '/main/home',
        name: 'home',
        meta: {
          title: '首页'
        },
        component: () => import('@/views/main/home/home.vue')
      },
      {
        // 产品与服务
        path: '/main/product',
        name: 'product',
        meta: {
          title: '产品与服务'
        },
        component: () => import('@/views/main/product/product.vue')
      },
      {
        // 查询-询价
        path: '/main/product/enquiry',
        name: 'enquiry',
        meta: {
          title: '查询-询价'
        },
        component: () => import('@/views/main/product/enquiry/enquiry.vue')
      },
      {
        // 轨迹-查询
        path: '/main/product/track',
        name: 'track',
        meta: {
          title: '轨迹-查询'
        },
        component: () => import('@/views/main/product/track/track.vue')
      },
      {
        // 服务介绍
        path: '/main/product/service',
        name: 'service-introduce',
        meta: {
          title: '服务介绍'
        },
        component: () =>
          import('@/views/main/product/service-introduce/service-introduce.vue')
      },
      {
        // 资讯中心
        path: '/main/information-center',
        name: 'information-center',
        meta: {
          title: '资讯中心'
        },
        component: () =>
          import('@/views/main/information-center/information-center.vue')
      },
      {
        // 资讯详情
        path: '/main/information-center/details',
        name: 'information-details',
        meta: {
          title: '资讯详情'
        },
        component: () =>
          import(
            '@/views/main/information-center/information-details/information-details.vue'
          )
      },
      {
        // 关于我们
        path: '/main/about',
        name: 'about',
        meta: {
          title: '关于我们'
        },
        component: () => import('@/views/main/about/about.vue')
      },
      {
        // 联系我们
        path: '/main/contact-us',
        name: 'contact-us',
        meta: {
          title: '联系我们'
        },
        component: () => import('@/views/main/contact-us/contact-us.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/login/login.vue')
  },
  // 找不到页面
  {
    path: '/404',
    name: 'notFound',
    meta: {
      title: '找不到页面'
    },
    component: () => import('@/views/not-found/not-found.vue')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

routerGuard(router)

export default router
